export enum CampagneFichierType {
  GUIDE_UTILISATEUR = 'GUIDE_UTILISATEUR',
  NOTICE = 'NOTICE',
}